export type SocialLinkPlatform = "facebook" | "instagram" | "website";

export type SocialLinkItem = {
  platform: SocialLinkPlatform;
  label: string;
  url: string;
};

export const KINDRED_WEBSITE_URL = "https://www.kindredcommunity.app";

export const KINDRED_SOCIAL_LINKS: SocialLinkItem[] = [
  {
    platform: "facebook",
    label: "Visit our Facebook Page",
    url: "https://facebook.com/singleparentspace",
  },
  {
    platform: "instagram",
    label: "Follow Kindred on Instagram",
    url: "https://www.instagram.com/kindredappuk/",
  },
  {
    platform: "website",
    label: "Visit kindredcommunity.app",
    url: KINDRED_WEBSITE_URL,
  },
];
